import { useDispatch } from 'react-redux';
import { fetchWishlists } from '@client/myAccount/wishlists/redux/wishlists/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useFetchWishlistsAction = (): typeof fetchWishlists => {
  const dispatch = useDispatch();

  return bindActionCreators(fetchWishlists, dispatch);
};
